function isURLValid(url) {
  if (typeof url !== 'string') return false;
  try {
    const test = new URL(url);
    return test.href;
  } catch (_) {
    return false;
  }
}
export default isURLValid;
//# sourceMappingURL=isURLValid.js.map